// extracted by mini-css-extract-plugin
export var logoWrapper = "cX_jr";